import { useNavigate } from "react-router-dom";
import { Building2, ChevronRight } from "lucide-react";
import { api } from "@/App";

// Native feed card: one ADE Pro suggestion interleaved between Now posts
export function ProSuggestionFeedCard({ pro }) {
  const navigate = useNavigate();
  if (!pro) return null;
  const pp = pro.professional_profile || {};

  const open = () => {
    api.post("/professionals/track", {
      events: [{ professional_user_id: pro.user_id, event_type: "click", source: "suggestions" }],
    }).catch(() => {});
    navigate(`/app/pro/${pro.user_id}`);
  };

  return (
    <article className="bg-white" data-testid={`pro-feed-card-${pro.user_id}`}>
      <div className="mx-4 my-2 rounded-2xl border border-blue-100 dark:border-blue-900/50 bg-gradient-to-br from-blue-50/80 via-cyan-50/60 to-white dark:from-blue-950/40 dark:via-slate-900/80 dark:to-slate-900/80 overflow-hidden">
        <div className="flex items-center justify-between px-4 pt-3">
          <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-blue-600">
            <Building2 className="w-3 h-3" /> ADE Pro · Suggerito per te
          </span>
          <button
            onClick={() => navigate("/app/professionals")}
            className="text-[11px] text-blue-600 font-medium flex items-center gap-0.5"
            data-testid="pro-feed-see-all"
          >
            Vedi tutte <ChevronRight className="w-3 h-3" />
          </button>
        </div>
        <button onClick={open} className="w-full flex items-center gap-3 px-4 py-3 text-left" data-testid={`pro-feed-open-${pro.user_id}`}>
          <img
            src={pro.picture || "/images/default-avatar.png"}
            alt=""
            className="w-12 h-12 rounded-xl object-cover bg-gray-100 flex-shrink-0"
          />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">{pp.professional_name || pro.name}</p>
            <p className="text-xs text-gray-500 truncate">{pp.category}{pp.city ? ` · ${pp.city}` : ""}</p>
            {pp.bio && <p className="text-[11px] text-gray-400 truncate mt-0.5">{pp.bio}</p>}
          </div>
          <span className="flex-shrink-0 text-xs font-semibold text-white bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full px-3.5 py-1.5">
            Scopri
          </span>
        </button>
      </div>
    </article>
  );
}
